import {Plane,Raycaster,Vector2,Vector3} from 'three';
// Grab on a screen-facing plane through the cloud, never on the clamped ground.
// This keeps the grabbed point attached to the pointer at any allowed orbit angle.
export function cloudGrabPoint(camera,event,rect,cloud){
 const ndc=new Vector2((event.clientX-rect.left)/rect.width*2-1,-(event.clientY-rect.top)/rect.height*2+1),ray=new Raycaster();ray.setFromCamera(ndc,camera);
 const origin=new Vector3(cloud.x,cloud.y,cloud.z),normal=camera.getWorldDirection(new Vector3()),plane=new Plane().setFromNormalAndCoplanarPoint(normal,origin);
 const p=ray.ray.intersectPlane(plane,new Vector3())||origin;return{x:p.x,y:p.y,z:p.z};
}
